import { render } from "./UserDetailsView.vue?vue&type=template&id=475b7885"
import script from "./UserDetailsView.vue?vue&type=script&lang=js"
export * from "./UserDetailsView.vue?vue&type=script&lang=js"

import "./UserDetailsView.vue?vue&type=style&index=0&id=475b7885&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__